// extracted by mini-css-extract-plugin
export var statusConfirmButtonWrap = "_80896f1b9cb3d83bf7c81a26ea3730a6-css";